import { useRecoilValue } from "recoil";
import { PubMemberDto } from "../../../../../api/member";
import { pubState } from "../../../../../recoil/pub.atom";
import {
  ManualPointHistoryHeader,
  ManualPointHistoryItemWrapper,
  ManualPointHistoryTable,
  ManualPointHistoryWrapper,
  ManualPointHistoryPageWrapper,
} from "../style";
import { useEffect, useState } from "react";
import { formatDate } from "../../../../../utils/date";
import { Title } from "../../../../../styles/page";
import {
  getMemberTransactionPointLogs,
  pointRefund,
  PointTransaction,
} from "../../../../../api/pub-point";
import { exchangePoint } from "../../../../../utils/number";

interface ManualPointHistoryProps {
  onClose: () => void;
  member: PubMemberDto | null;
  getMemberData: () => void;
}
const ManualPointHistory = ({
  onClose,
  member,
  getMemberData,
}: ManualPointHistoryProps) => {
  const pub = useRecoilValue(pubState);
  const size = 10;
  const [list, setList] = useState<PointTransaction[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);

  const getData = async () => {
    if (!pub || !member) return;
    try {
      const res = await getMemberTransactionPointLogs(
        member.memberId,
        currentPage,
        size,
      );
      setTotalPage(Math.max(1, Math.ceil(res.total / size)));
      setList(res.list);
    } catch {
      setList([]);
    }
  };

  const handleRefundPoint = async (refundId: number) => {
    const confirm = window.confirm("포인트 환불을 진행하시겠습니까?");
    if (!confirm) return;

    try {
      await pointRefund(refundId);
      alert("처리 되었습니다. ");
      getData();
      getMemberData();
    } catch {
      alert("재시도해주세요. ");
    }
  };

  useEffect(() => {
    getData();
  }, [member]);

  useEffect(() => {
    getData();
  }, [currentPage]);

  const onPageChange = async (nextPage: number) => {
    if (currentPage + nextPage <= 0) return;
    if (currentPage + nextPage > totalPage) return;
    setCurrentPage(currentPage + nextPage);
  };

  return (
    <ManualPointHistoryWrapper>
      <ManualPointHistoryHeader>
        <Title size={20}>내역</Title>
        <div className="right">
          <div className="name">
            보유 포인트 <span>{exchangePoint(member?.point)}E</span>
          </div>
          <img
            src="/image-web/solution/close.svg"
            alt="close"
            onClick={() => onClose()}
          />
        </div>
      </ManualPointHistoryHeader>
      <ManualPointHistoryTable>
        <div className="header">
          <div className="item">날짜</div>
          <div className="item">구분</div>
          <div className="item">지급 E</div>
          <div className="item">메모</div>
          <div className="back"></div>
        </div>
        <div className="body">
          {list.length === 0 ? (
            <div className="no-data">내역이 없습니다. </div>
          ) : (
            list.map((item, index) => (
              <ManualPointHistoryItemWrapper key={index}>
                <div className="item">{formatDate(item.createdAt)}</div>
                <div className="item">
                  {item.pointAmount > 0 ? "지급" : "지급 취소"}
                </div>
                <div className="item">{exchangePoint(item.pointAmount)}</div>
                <div className="item">{item.memo}</div>
                <div
                  className="back"
                  onClick={() => {
                    if (!item.isRefund && item.pointAmount > 0) {
                      handleRefundPoint(item.id);
                    }
                  }}
                >
                  {!item.isRefund && item.pointAmount > 0 ? "환불" : ""}
                </div>
              </ManualPointHistoryItemWrapper>
            ))
          )}
        </div>
      </ManualPointHistoryTable>
      <ManualPointHistoryPageWrapper>
        <img
          src="image-web/solution/page-left.png"
          alt="arrow"
          onClick={() => onPageChange(-1)}
        />
        <div className="page">
          {currentPage} / {totalPage}
        </div>
        <img
          src="image-web/solution/page-right.png"
          alt="arrow"
          onClick={() => onPageChange(1)}
        />
      </ManualPointHistoryPageWrapper>
    </ManualPointHistoryWrapper>
  );
};

export default ManualPointHistory;
